/**
 * recruit
 */
'use strict';
import AppRecruitEntry from '@/_modules/app_recruit_entry';

document.addEventListener('DOMContentLoaded', () => {
  new AppRecruitEntry();
}, false);

window.addEventListener('load', () => {

}, false);

window.addEventListener('unload', () => {}, false);

window.addEventListener('pageshow', function(event){
  if (event.persisted) {
    window.location.reload();
  }
});
